<template>
  <div class="min-height theme--light v-card pa-4 cbg-white-container">
    <v-row>
      <v-col cols="12" sm="12" lg="10" class="input-container">
        <v-row>
          <v-col cols="12" sm="6" lg="3" class="form-group pb-0 pb-lg-3 mb-1 mb-lg-3">
            <label for class="fz-10px">Search by Name / Mobile Number</label>
            <div class="search-div position-relative">
              <input 
              class="form-control"
              placeholder="Name" 
              v-model="searchParameter.centerName"
              @input="debounceSearch(true)"
              />
              <div
                v-if="searchParameter.centerName !== ''"
                class="search-svg"
                @click="clearSearch()"
              >
                <crossSVG />
              </div>
            </div>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" sm="12" lg="2" class="d-flex  justify-end mt-0 mt-lg-6">
        <v-btn class="btn btn-primary mr-0 px-6 py-5 "
        @click="downloadCsv()"
        >
          Export</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div class="overflow-auto">
          <!-- changes done by durgesh on 21-1-2022 -->
          <table class="table userlistTable table-width add-table-width">
            <thead>
              <tr class="table-success">
                <!-- 0 -->
                <th scope="col" class="min-width-120">Owner Name</th>
                <!-- 1 -->
                <th scope="col">Mobile Number</th>
                <!-- 2 -->
                <th scope="col">Centre name</th>
                <!-- 3 -->
                <!-- <th scope="col">Role</th> -->
                <!-- 5 -->
                <th scope="col" class="min-width-130">Location</th>
                <!--6-->
                <th scope="col">Centre's Discount Percentage</th>
                <!-- 7 -->
                <th scope="col" class="min-width-140">
                  Insurance company names
                </th>
                <!-- 8 -->
              </tr>
            </thead>

            <!-- filter row -->
            <tbody v-if="!isEmpty">
              <tr>
                <!-- Owner Name-->
                <td>
                  <input
                  class="form-control"
                            label="Search by Name"
                            placeholder="Name"
                            v-model="searchParameter.ownerName"
                            @input="debounceSearch(true)"
                    />
                </td>

                <!-- Mobile Number -->
                <td>
                  <input
                    placeholder="Mobile Number"
                    v-model="searchParameter.number"
                    class="form-control"
                    type="number"
                    @input="debounceSearch(true)"
                  />
                </td>

        
                <!-- Centre Name -->
                 <td>
                  <input
                    placeholder="Name"
                    v-model="searchParameter.centerName"
                    class="form-control"
                    @input="debounceSearch(true)"
                  />
                </td>
                <!-- Location  -->
                <td>
                  <input
                  class="form-control"
                  placeholder="Location"
                  v-model="searchParameter.location"
                  @input="debounceSearch(true)"
                    />
                </td>
                <td>
                </td>
                <!-- Insurance company names   -->
                <td>
                  <input
                    placeholder="Insurance List"
                  @input="debounceSearch(true)"
                  v-model="searchParameter.insurance_list"
                    
                    class="form-control"
                  />
                </td>
              </tr>

              <tr v-for="(list, index) in centerList" :key="index">
                  <td class="pt-4 pb-4">{{list.created_by.full_name}}</td>
                  <td class="pt-4 pb-4">{{list.created_by.mobile}}</td>
                  <td class="pt-4 pb-4">{{list.general.name}}</td>
                  <td class="pt-4 pb-4">{{list.general.address.city ? list.general.address.city : '-'}}</td>
                  <td class="pt-4 pb-4">{{list[`${list.center_type}`].docsmart_insurance.insurance_discount}}</td>
                  <td class="pt-4 pb-4" v-if="list[`${list.center_type}`].insurance_companies.length">
                    {{ list[`${list.center_type}`].insurance_companies[0].name }}
                     <span v-if="list[`${list.center_type}`].insurance_companies.length > 1" class="d-block text-success font-weight-bold cursor pt-1" @click="showCompanyInsuranceList(list[`${list.center_type}`].insurance_companies)"> + {{ list[`${list.center_type}`].insurance_companies.length - 1 }} more</span>
                    </td>
              </tr>
            </tbody>

            <tbody v-if="isEmpty">
              <tr>
                <td colspan="10">
                  <h2 class="text-center">No Data Found</h2>
                </td>
              </tr>
            </tbody>
          </table>
          <pagination
            v-if="isEmpty"
            class="mx-0 mob-t-center pagination-block"
            :recordPerPage="recordPerPage"
            :total="total"
            @changePage="changePage"
          />
        </div>
      </v-col>
    </v-row>
      <v-dialog v-model="companySpeciality" width="500" persistent id="view-box">
        <show-speciality 
        @close="companySpeciality=false, insurance_name=[]"
        :insuranceName = insurance_name
        :title = "insurance_name.length ? 'Insurance List' : null"
        />
      </v-dialog>
  </div>
</template>
<script>
// import config from "@/config.js";
import { pickSvg } from "@/views/SVG";
import debounce from "lodash/debounce";
import config from "@/config.js";
import { bus } from "@/main.js";
export default {
  components: {
    pagination: () => import("@/views/common/Pagination"),
  },
  data() {
    return {
      search: "",
      isEmpty: false,
      roleStatus: "",
      centerList: [],
      total: "",
      insurance_name: [],
      currentPage: 1,
      recordPerPage:10,
      companySpeciality: false,
      searchParameter: {
        ownerName: "",
        centerName: "",
        number: "",
        location: "",
        type_of_center: "",
        insurance_list: "",
        is_generic: "",
      },
    };
  },
  components: {
      'show-speciality': () => import('@/components/modals/newSpeciality'),
    ...pickSvg("crossSVG", "verticalDotsSVG"),
  },
  mounted() {
    this.debounceSearch();
  },
  methods: {
    showCompanyInsuranceList(data){
        if(data){
          data.forEach((type) => {this.insurance_name.push(type.name)})
        }
          this.companySpeciality = true
      },
      clearSearch() {
      this.searchParameter.centerName = "";
      this.debounceSearch(true);
    },
    changeRole() {
      this.debounceSearch(true);
    },
    changePage(page = { currentPage: 1, reduced: false }, reset = false) {
      if (reset) {
        bus.$emit("PAGE_CHANGE");
        page = { currentPage: 1, reduced: false }
      }
      if (!page.reduced) {
        this.currentPage = page.currentPage;
        this.debounceSearch(true);
      } else {
        this.currentPage = 1;
        this.$forceUpdate();
      }
    },
    getInsuranceCenterList() {
      let params = {
        page: this.currentPage,
        records_per_page: this.recordPerPage,
        owner_name: this.searchParameter.ownerName,
        center_name: this.searchParameter.centerName,
        is_part_of_docsmart_insurance: true,
        mobile: this.searchParameter.number,
        city: this.searchParameter.location,
        insurance_company_name: this.searchParameter.insurance_list,
      }
      this.roleStatus = this.$route.path.replace('/insurance-','')
      let url = `${config.BASE_URL}api/v2/admin/center-list/${this.roleStatus}`;
      this.$http.get(url,{ params }).then((response) => {
        if (response.body.status) {
          if(response.body.data.list.length){
            this.isEmpty = false;
            this.centerList = response.body.data.list;
            this.centerList.map((el) => {
              Object.keys(el).map((element) => {
                switch (element) {
                  case "pharmacy":
                  return (el.role = element);
                  break;
                  case "diagnostics-lab":
                    return (el.role = element);
                    break;
                  case "bloodbank":
                    return (el.role = element);
                    break;
                  case "ambulance":
                    return (el.role = element);
                    break;
                }
              });
            });
            this.total = response.body.data.count;
          }
          else{
            this.centerList = [];
            this.isEmpty = false;
          }
        }
      });
    },

        downloadCsv() {
      this.$store.commit("general/setLoader", true);
    
      let params = {
        owner_name: this.searchParameter.ownerName,
        center_name: this.searchParameter.centerName,
        is_docsmart_insurance: true,
        mobile: this.searchParameter.number,
        city: this.searchParameter.location,
        role: this.roleStatus,
        sort_by:
          this.$router.currentRoute.name == "User Listing" ? "created_at" : "",
      };
      let url = `${config.BASE_URL}api/v2/admin/center-list-csv/${this.roleStatus}`;
      this.$http.get(url, { params }).then((response) => {
        if (response.body.status) {
          const data = response.data.data;
          this.download(data.fileName, data.csv);
        }
      });
    },
    download(filename, text) {
      var element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(text)
      );
      element.setAttribute("download", filename);

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    },



    debounceSearch: debounce(function (pageReset = false) {
      if (pageReset) {
        bus.$emit("PAGE_CHANGE");
        this.currentPage = 1;
      }
      this.getInsuranceCenterList();
    }, 500),
  },
  watch: {
    $route: {
      immediate: true,
      handler (route) {
       if (route && route.path) {
        this.roleStatus = this.$route.path.replace('/insurance-','')   
        this.debounceSearch();
        }
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.ww-50 {
  width: 50px;
}
.action-div {
  .dropdown-menu {
    padding: 0px !important;
  }
}
</style>
